import React from "react";
import * as S from "./DriverProfile.styles";

interface IPersuasion {
  icon: string;
  text: string;
}

interface ICabDriverProfile {
  margin: string;
  title: string;
  persuasions: Array<IPersuasion>;
}

const DriverProfileUI: React.FC<ICabDriverProfile> = ({
  margin = '',
  title = '',
  persuasions = []
}) => {
  if (!persuasions?.length) return null;
  return (
    <S.DriverProfileContainer margin={margin}>
      <h4 className="font16 fontMedium textDark">{title}</h4>
      <div className="makeFlex column">
        {persuasions?.map(({ icon = '', text = '' }, index) => {
          return (
            <div key={index} className="makeFlex htlCenter">
              {!!icon && <img className="appendRight8" src={icon} alt="tick" />}
              {!!text && <p className="font14 textDark">{text}</p>}
            </div>
          );
        })}
      </div>
    </S.DriverProfileContainer>
  );
};

export default DriverProfileUI;
